import Downshift, { DownshiftState, StateChangeOptions } from 'downshift';
import dynamic from 'next/dynamic';
import React from 'react';
import { IItem, IItems } from './common/interface';
/**
 * This is being done because for integration tests, these imports
 * are immediately needed and thus mocking out dynamic won't work.
 * Dynamic isn't working correctly with jest as it doesn't recognize this.
 * There are two babel transpilers (dynamic-import-node and transform-dynamic-import)
 * for this but there was some issue with both of them.
 *
 * @TODO Use a babel transpiler for dynamic and mock the correct file in the tests.
 * Look into this issue for more help: https://github.com/zeit/next.js/issues/5416
 * There is a library for doing the whole thing but there was some issue with the
 * transpiler still: https://github.com/FormidableLabs/jest-next-dynamic
 */
const MobileSelect =
    process.env.NODE_ENV === 'test'
        ? require('./mobile/mobile-select').default
        : dynamic(import('./mobile/mobile-select'));
const DesktopSelect =
    process.env.NODE_ENV === 'test'
        ? require('./desktop/desktop-select').default
        : dynamic(import('./desktop/desktop-select'));

interface IProps {
    onSelectHandler: (selectedItem: IItem | null) => void;
    items: IItems;
    heading: string;
    selectAllText: string;
    placeholder: string;
    withModal: boolean;
    selectedItem?: IItem | null;
    className?: string;
}

export const SearchDropdown = (props: IProps) => {
    const Select = props.withModal ? MobileSelect : DesktopSelect;

    const stateReducer = (_state: DownshiftState<IItem>, changes: StateChangeOptions<IItem>) => {
        //set inputValue as empty when the submenu is open and there is no change type found.
        if (changes.isOpen && !changes.type) {
            return { ...changes, inputValue: '' };
        }
        switch (changes.type) {
            case Downshift.stateChangeTypes.controlledPropUpdatedSelectedItem:
            case Downshift.stateChangeTypes.mouseUp:
            case Downshift.stateChangeTypes.blurInput:
            case Downshift.stateChangeTypes.keyDownEnter:
            case Downshift.stateChangeTypes.clickItem:
                return { ...changes, inputValue: '' };
            case Downshift.stateChangeTypes.keyDownEscape:
                props.onSelectHandler(null);
                return changes;
            default:
                return changes;
        }
    };

    return (
        <div data-testid="search-dropdown" className={props.className}>
            <Select
                placeholder={props.placeholder}
                items={props.items}
                heading={props.heading}
                selectAllText={props.selectAllText}
                stateReducer={stateReducer}
                onSelectHandler={props.onSelectHandler}
                selectedItem={props.selectedItem}
            />
        </div>
    );
};
